import { adminApi } from "../utils/admin-api-axios";

export const getAllUsers = async () => {
  try {
    const response = await adminApi.getAllUsers();
    if (response.success) {
      return response;
    }
  } catch (error) {
    console.error("Error fetching listings:", error);
    throw error;
  }
};
